function fullyear() {
  const currentYear = new Date().getFullYear();

  return currentYear.toString();
}

export default fullyear;